module.exports = __webpack_public_path__ + "static/media/up.5816ed89.svg";